// extracted by mini-css-extract-plugin
export default {"manage-maris-grid-container":"page_manage-maris-grid-container__K6U6g","overflow-content":"page_overflow-content__5n2KE"};